<template>
  <v-container fluid>
    <portal to="app-header">
      {{ $t('kpiDashboard') }}
    </portal>
    <component :is="component" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AdminDashboard from '../components/AdminDashboard.vue';
import ProductionSupervisorDashboard from '../components/ProductionSupervisorDashboard.vue';
import MachineDashboard from '../components/MachineDashboard.vue';

export default {
  name: 'kpiDashboard',
  components: {
    AdminDashboard,
    MachineDashboard,
    ProductionSupervisorDashboard,
  },
  computed: {
    ...mapGetters('user', ['roleName']),
    ...mapState('user', ['licenses']),
    isCnc() {
      // return this.licenses.length === 1 && this.licenses[0].assetId === 9;
      return false;
    },
    component() {
      if (this.isCnc) {
        return 'machine-dashboard';
      }
      switch (this.roleName) {
        case 'planthead':
          return 'production-supervisor-dashboard';
        case 'planner':
          return 'production-planner-dashboard';
        case 'supervisor':
          return 'production-supervisor-dashboard';
        default:
          return 'production-supervisor-dashboard';
      }
    },
  },
};
</script>
